<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
    <main class="page-content">
        <div class="bgColor">
            <div class="container">
                <div class="row" style="height: 4em;">
                    <div class="col-md-6">
                        <p class="appTitle">Add Material Syllabus</p>
                    </div>
                    <div class="col-md-6">
                        <p class="adminName">{{ adminName }} <img width="30px" height="30px" style="margin-left:0.5em;" [src]="adminImage" class="rounded-circle"></p>
                    </div>
                </div>

                <div class="row my-4">
                    <div class="col">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-4 searchCol">
                                    <div class="form-inline">
                                        <input class="form-control form-control-sm ml-3 w-75" type="text" (change)="onChangeEvent($event)" placeholder="Materials" aria-label="Search" [(ngModel)]="searchval">
                                        <i class="fa fa-search searchIcon" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="col-md-3 searchCol">
                                    <button type="button" class="btn btn-primary" (click)="reset()">Reset</button>
                                </div>
                                <div class="col-md-3 searchCol">
                                    <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()"><i
                                            class="fa fa-plus" aria-hidden="true"></i> Add Syllabus</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="row" *ngIf="showData">
                    <div class="col-md-5 degreeContent" *ngFor="let course of allCourse">
                        <div class="row">
                            <div class="col-md-8">
                                <p style="text-align: left;font-size: 0.8em;">{{ course.courses }}</p>
                            </div>
                            <div class="col-md-4">
                                <i class="fa fa-trash-o iconEdit" #boxCourse (mouseover)="onMouseOver($event)" aria-hidden="true" (click)="deleteCourse(course)"></i>
                                <i class="fa fa-pencil iconEdit" #boxCourse (mouseover)="onMouseOver($event)" (click)="editCourse(course)" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div *ngIf="showData">
                    <div class="displayImages" *ngFor="let image of allCollegeImages;let indexOfelement=index;">
                        <div class="row" style="margin-bottom: 0.7em; margin-top: 0.7em;">
                            <div class="col-md-6">
                                <h2>{{ image.category }}</h2>
                            </div>
                            <div class="col-md-6" style="text-align:right;">
                                <button type="button" class="btn btn-primary addCourseBtn" (click)="viewImages(indexOfelement)">View All</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" *ngFor="let img of image.lessData" style="margin-bottom: 1em !important;">
                                <div class="img-wraps">
                                    <img class="clgImg" [src]="img.images">
                                    <i class="fa fa-trash-o closes" aria-hidden="true" (click)="deletematerialcategorysyllabus(img.image_id)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="noData" *ngIf="showNodata">
                    <h2>Currenly No Data Available!</h2>
                </div>

            </div>

            <div class="backdrop" [ngStyle]="{'display':display}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header" *ngIf="showAdd">
                            Add Colleges
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <!-- <div class="modal-header" *ngIf="showEdit">
                            Edit Courses
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div> -->
                        <div class="dltmodal-content animate modal-body dltBl">
                            <form [formGroup]="courseForm">

                                <select class="form-control" formControlName="categorytypeval" addSubject [(ngModel)]="category">
                                    <option  *ngFor="let mcategory of materialdata;let x = index" [ngValue]="mcategory.id">{{
                                        mcategory.category }}</option>
                                </select>
                                <!-- <input type="file"> -->


                                <label class="uploadImage">Upload Syllabus
                                    <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                                    
                                    <!-- <input type="file"> -->

                                    <input type="file" formControlName="colgImg" (change)="handleFileInput($event)"
                                        multiple="" >
                                </label>
                                <!-- <img class="multipleImg" width="80px" height="80px"> -->

                                <!-- <img class="multipleImg" width="80px" height="80px" *ngFor="let img of images" [src]="img"> -->
                                <!-- <select class="form-control" formControlName="degreetypeVal" [(ngModel)]="courseName">
                                    <option *ngFor="let degreetype of degreeTypeData;let x = index" [ngValue]="degreetype.id"></option>
                                </select> -->
                                <!-- <div class="error-messages">
                                    <div *ngFor="let error of error_messages.collegeval">
                                        <div class="error-message" *ngIf="courseForm.get('collegeval').hasError(error.type) && (courseForm.get('collegeval').dirty || courseForm.get('collegeval').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>

                                </div> -->

                                <div class="addBtn" *ngIf="showAdd">
                                    <button class="commonBtn mt-2" (click)="addsyllabus()">
                                        Add
                                        Colleges</button>
                                </div>

                                <!-- <div class="addBtn" *ngIf="showEdit">
                                    <button class="commonBtn mt-2" [disabled]="!courseForm.valid" (click)="updateCourse()">
                                        Update</button>
                                </div> -->
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                            <p>Do you want to delete Course ?</p>
                            <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
                            <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                            <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                        </div>
                    </div>
                </div>
            </div> -->

        </div>
    </main>
</div>